"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.RadioGroup = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../../Elements/Icon/Icon");
var _RadioInput = require("../RadioInput/RadioInput");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/jsx-props-no-spreading */

/**
 * Primary UI component for text
 */
const RadioGroup = ({
  name,
  label,
  hint,
  optionalText,
  error,
  errorMsg,
  disabled,
  fields,
  className,
  ...props
}) => {
  const cssComponentClass = 'ccl__form-input';
  const cssTextClass = 'ccl__text';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: [cssComponentClass, `${cssComponentClass}--is-radio-group`, error ? `${cssComponentClass}--has-error` : '', disabled ? `${cssComponentClass}--is-disabled` : '', className].join(' '),
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: `${cssComponentClass}__label ${cssTextClass} ${cssTextClass}--body-text-bold`,
      children: [label, optionalText && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: `${cssComponentClass}__label__optional ${cssTextClass} ${cssTextClass}--small-body-text-italic`,
        children: `(${optionalText})`
      })]
    }), hint && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: `${cssComponentClass}__hint ${cssTextClass} ${cssTextClass}--informative-text`,
      children: hint
    }), error && /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: `${cssComponentClass}__error-message ${cssTextClass} ${cssTextClass}--error-small-text`,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        color: "error",
        type: "error",
        size: "sm"
      }), errorMsg]
    }), fields.map(field => /*#__PURE__*/(0, _jsxRuntime.jsx)(_RadioInput.RadioInput, {
      name: name,
      id: field.id,
      value: field.value,
      label: field.label,
      disabled: field.disabled || disabled,
      checked: field.checked,
      setFocus: field.setFocus
    }, field.id))]
  });
};
exports.RadioGroup = RadioGroup;
RadioGroup.defaultProps = {
  hint: '',
  optionalText: '',
  error: false,
  errorMsg: '',
  disabled: false
};